/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> le contenu. Voici un exemple simple
 * exemple :
 *
 * // Assurez-vous d'ajouter les attributs HTML "aria-controls", "aria-expanded" et "is" à votre bouton :
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Tiroir ouvert</button>
 *
 * <drawer-content id="id-of-drawer">
 * Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('cart:updated', function(event) {
  
   var cart = event.detail.cart; 
  if(cart.items_removed.length > 0) {
  let removed_item_id = cart.items_removed[0].variant_id;
   //console.log(removed_item_id);
   let is_exist = false;
   for(var item = 0; item < cart.items.length; item++) {
    let item_id = cart.items[item].id;
    if(item_id === removed_item_id) {
      is_exist = true;
    }
   }

   let want_remove_id = 0;
   let line = [];
   if(is_exist === false) {
     for(var item = 0; item < cart.items.length; item++) {
      let item_id = parseInt(cart.items[item].properties._bundle_id)
      if(item_id === removed_item_id) {
        want_remove_id = cart.items[item].id;
        let i = item + 1;
        line.push('/cart/change?quantity=0&id='+want_remove_id);
      }
     }
   }
 
   if(want_remove_id !== 0){
      _updateFromLink(line)
   }
  }
  
  //console.log(cart);
});

async function _updateFromLink(line) {
  let count = line.length;
  let lines = line;
  for(var i = 0; i < line.length; i++) {
  let link = lines[i];
  const changeUrl = new URL(link, `https://${window.themeVariables.routes.host}`), searchParams = changeUrl.searchParams, line = searchParams.get("line"), id = searchParams.get("id"), quantity = parseInt(searchParams.get("quantity"));
  this.dispatchEvent(new CustomEvent("line-item-quantity:change:start", { bubbles: true, detail: { newLineQuantity: quantity } }));
  const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
    body: JSON.stringify({ line, id, quantity, sections: ["mini-cart"] }),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  });
   const cartContent = await response.json();
   this.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: true, detail: { cart: cartContent, newLineQuantity: quantity } }));
    
    let a = i + 1;
    if(a === count) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
      bubbles: true,
      detail: {
        cart: cartContent
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart: cartContent,
        replacementDelay: quantity === 0 ? 600 : 750
      }
    }));
   }
  }
  
}

// js/helper/event.js
function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      detail: data
    }));
  }

function changeUrl(val) {
  triggerEvent(document.documentElement, "theme:loading:start");
  location.replace(val);
  setTimeout(function() {
    triggerEvent(document.documentElement, "theme:loading:mid");
  }, 600);
  setTimeout(function() {
    triggerEvent(document.documentElement, "theme:loading:end");
  }, 1000);
}

function changeImgUrl(val1, val2, val3, val4, val5) {
  triggerEvent(document.documentElement, "theme:loading:start");
  // Primary Image 
  document.querySelector('.'+val3+' .product-item__image-wrapper img.product-item__primary-image').setAttribute('src', val1);
  document.querySelector('.'+val3+' .product-item__image-wrapper img.product-item__primary-image').setAttribute('srcset', val1);
  //Secondary Image
  document.querySelector('.'+val3+' .product-item__image-wrapper img.product-item__secondary-image').setAttribute('src', val5);
  document.querySelector('.'+val3+' .product-item__image-wrapper img.product-item__secondary-image').setAttribute('srcset', val5);
  document.querySelector('.'+val3+' .product-item__image-wrapper a').setAttribute('href', val2);
  var radio = document.querySelector('.'+val3+' .color-swatch input[type=radio]:checked');
  radio.checked = false;
  document.querySelector('.'+val4).checked = true;
 
  
  setTimeout(function() {
    triggerEvent(document.documentElement, "theme:loading:mid");
  }, 400);
  setTimeout(function() {
    triggerEvent(document.documentElement, "theme:loading:end");
  }, 700);
}

function setHighlightBilderHeight() {
    var productListInners = document.querySelectorAll('.product-list__inner');
    productListInners.forEach(function(productListInner) {
        var productItems = productListInner.querySelectorAll('.product-item');
        // Reset the height for all items first
        productItems.forEach(function(productItem) {
            productItem.style.height = '';
        });
        // Determine the minimum height among the non-highlighted product-item elements
        var minHeight = Array.from(productItems).reduce(function(min, productItem) {
            if (!productItem.classList.contains('highlight_bilder')) {
                var itemHeight = productItem.offsetHeight;
                return Math.min(min, itemHeight);
            }
            return min;
        }, Infinity);
        // Apply the minimum height to elements with the highlight_bilder class
        productItems.forEach(function(productItem) {
            if (productItem.classList.contains('highlight_bilder')) {
                productItem.style.height = minHeight + 'px';
            }
        });
    });
}

function initObserver() {
    // Check screen width
    if (window.innerWidth > 1000) return;

    const targetElement = document.getElementById('mini-cart');

    if (!targetElement) {
        console.warn('Element with ID mini-cart not found');
        return;
    }

    const observer = new MutationObserver((mutationsList) => {
        for(let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                const weglotElement = document.querySelector('.weglot-container');
                
                if (weglotElement) {
                    weglotElement.style.opacity = targetElement.hasAttribute('open') ? '0' : '1';
                } else {
                    console.warn('Element with class weglot-container not found');
                }
            }
        }
    });

    const config = { attributes: true, childList: false, subtree: false };
    observer.observe(targetElement, config);
}

function handleLabelsAndBadges() {
    // Select all elements with class 'product-item'
    const productItems = document.querySelectorAll('.product-item');

    productItems.forEach(item => {
        // Check if 'only-custom-badge' exists within the current 'product-item'
        const onlyCustomBadge = item.querySelector('.only-custom-badge');
        if (onlyCustomBadge) {
            // Find the previous sibling
            let prevElement = onlyCustomBadge.previousElementSibling;

            // If the previous sibling has class 'label--price-save', remove it
            if (prevElement && prevElement.classList.contains('label--price-save')) {
                prevElement.remove();
            }
        }
    });

    var labels = document.querySelectorAll('.label');

    labels.forEach(function(label, index) {
        setTimeout(function() {
            label.style.opacity = "1";
        }, 50 * (index + 1));
    });
}

function triggerColorSwatchClicks() {
      if(document.body.classList.contains('template-collection')) {

    // Get all the elements with the class 'color-swatch-list'
    var colorSwatchLists = document.querySelectorAll('.color-swatch-list');

    // Check if we have any 'color-swatch-list'
    if(colorSwatchLists.length) {
        // Iterate over each 'color-swatch-list'
        colorSwatchLists.forEach(function(swatchList) {
            // For each 'color-swatch-list', get the first 'color-swatch'
            var firstColorSwatch = swatchList.querySelector('.color-swatch');

            // Check if the 'color-swatch' exists
            if(firstColorSwatch) {
                // Get the 'input' with class 'color-swatch__radio' inside the first 'color-swatch'
                var inputRadio = firstColorSwatch.querySelector('.color-swatch__radio');

                // If there's an input, trigger a click on it
                if(inputRadio) {
                    inputRadio.click();
                }
            }
        });
    }
      }
}

function replaceSVGs() {
    // Function to replace SVG for a given selector and new SVG string
    function replaceSVG(selector, newSVGString) {
        var targetElement = document.querySelector(selector);
        
        if (targetElement) {
            var svgElement = targetElement.querySelector('svg');
            if (svgElement) {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = newSVGString;
                svgElement.replaceWith(tempDiv.firstChild);
            }
        }
    }

    // SVG for .flickity-prev-next-button.next
    replaceSVG('.flickity-prev-next-button.next',
               '<svg class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 22 42"><path d="M21.0734 21.1012L1.55594 1.58203M1.33105 40.43L20.8486 20.9108" stroke="#3f4049" stroke-width="3"></path></svg>') ;

    // SVG pour .flickity-prev-next-button.previous
    replaceSVG('.flickity-prev-next-button.previous',
               '<svg class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 22 42"><path d="M0.925824 20.9105L20.4433 40.4297M20.6682 1.58176L1.15071 21.1009" stroke="#3f4049" stroke-width="3"></path></svg>');
}


function removeTransform() {
    // Check if the body has the class 'template-product'
    if (document.body.classList.contains('template-product')) {
        var elements = document.querySelectorAll('.color-swatch-list .flickity-slider');

        elements.forEach(function(el) {
            el.style.transform = '';
        });
    }
}

function removeIncorrectOptions() {
    const productForm = document.querySelector('.product-form');

    // If productForm does not exist, exit the function
    if (!productForm) return;

    const selectElem = productForm.querySelector('#product-select-gerat');

    // If selectElem does not exist, exit the function
    if (!selectElem) return;

    // Extract the relevant classes from product-form
    let relevantClasses = Array.from(productForm.classList).filter(cls => cls !== 'product-form');

    // Create a map to store the final options based on their innerText
    const finalOptionsMap = new Map();

    Array.from(selectElem.options).forEach(option => {
        const matchesAllClasses = relevantClasses.every(cls => option.classList.contains(cls));
        
        if (matchesAllClasses) {
            finalOptionsMap.set(option.innerText, option);
        } else if (!finalOptionsMap.has(option.innerText)) {
            finalOptionsMap.set(option.innerText, option);
        }
    });

    // Clear the select element
    selectElem.innerHTML = '';

    // Populate the select with the final options
    finalOptionsMap.forEach(option => {
        selectElem.appendChild(option);
        if (option.selected) {
            selectElem.selectedIndex = Array.from(selectElem.options).indexOf(option);
        }
    });

    refreshSelectedOption();
}



function refreshSelectedOption() {
    var selectElement = document.getElementById("product-select-gerat");

    if (!selectElement) {
        console.warn("Select element with id 'product-select-gerat' not found!");
        return;
    }

    var selectedOption = selectElement.querySelector('option[selected="selected"]');

    if (selectedOption) {
        // Remove and set the selected attribute to force a redraw/update
        selectedOption.removeAttribute("selected");
        selectedOption.setAttribute("selected", "selected");

        // Clone and replace the select element to force the browser to acknowledge the change
        const clonedSelect = selectElement.cloneNode(true);
        selectElement.parentNode.replaceChild(clonedSelect, selectElement);
    } else {
        console.warn("No option with 'selected' attribute found!");
    }
}

function reformatPrices() {
    let lang = document.documentElement.getAttribute("lang");
    if (!["en", "fr"].includes(lang)) {
        return;  // Exit if lang is not "en" or "fr"
    }

    // Select all price elements including those with price--compare class
    let priceContainers = document.querySelectorAll(".price, .price--compare");

    priceContainers.forEach(container => {
        // Check if it's already in the desired format
        let currentText = container.textContent.trim();
        if (/^\d+<span class="visually-hidden">.+<\/span>,\d+€$/.test(currentText)) {
            return; // Skip to the next container
        }

        let visuallyHiddenSpan = container.querySelector('.visually-hidden');
        if (visuallyHiddenSpan) {  // Check if the span exists within the container
            let visuallyHiddenText = visuallyHiddenSpan.textContent.trim();
            
            // Match any number followed by an optional € symbol
            let match = visuallyHiddenText.match(/(\d+)(€?)/);
            
            if (match) {
                let numberPart = match[1];
                let euroSign = match[2];

                // Remove the matched part from the visually-hidden span
                visuallyHiddenSpan.textContent = visuallyHiddenText.replace(match[0], '').trim(); // Trim to remove any remaining whitespace

                if (euroSign) {
                    container.insertBefore(document.createTextNode(euroSign), visuallyHiddenSpan);
                }
                container.insertBefore(document.createTextNode(numberPart), visuallyHiddenSpan);
            }
        }
    });
}


document.addEventListener("click", function(event) {
    if (event.target.getAttribute("aria-controls") === "mini-cart") {
      setTimeout(reformatPrices, 50);
    }
});


document.addEventListener('DOMContentLoaded', function () {


setTimeout(reformatPrices, 50);


  
setTimeout(removeIncorrectOptions, 150);

removeTransform();
replaceSVGs();
triggerColorSwatchClicks();
handleLabelsAndBadges();
initObserver();

     // Check if body contains class template-collection
    if (document.body.classList.contains('template-collection')) {
        
        // Check if showmore-button-description exists
        var showMoreButton = document.getElementById('showmore-button-description');
        if (!showMoreButton) { // If it does not exist
            
            // Get the description element
            var descriptionElement = document.getElementById('description');
            if (descriptionElement) {
                // Set its height to auto
                descriptionElement.style.height = 'auto';
                descriptionElement.style.setProperty('height', 'auto', 'important'); // To ensure it overwrites the !important in CSS
            }
        }
    }

  // Check if the body has the class 'template-product'
  var isTemplateProduct = document.body.classList.contains('template-product');

  // Select all elements with the class 'rating__caption'
  var elements = document.querySelectorAll('.rating__caption');

  // Check if elements were found
  if (elements.length > 0) {
    // For each element
    elements.forEach(function(element) {
      // Get the inner text
      var text = element.innerText;

      // Use a regex to extract the number from the start of the text
      var match = text.match(/(\d+)/);

      // If a number was found
      if (match) {
        // If the body has the class 'template-product', keep the entire text
        if (isTemplateProduct) {
          element.innerText = '(' + text + ')';
        } else {
          // Otherwise, keep only the number
          element.innerText = '(' + match[0] + ')';
        }
      }
    });
  }

  // Set the opacity of each element with class 'product-item-meta__reviews-badge' to 1 after a delay of 1 second
  setTimeout(function() {
    var badges = document.querySelectorAll('.product-item-meta__reviews-badge');
    if (badges.length > 0) {
      badges.forEach(function(badge) {
        badge.style.opacity = '1';
      });
    }
  }, 200);



    // Select all SVG elements with the class 'icon--rating-star-half'
  var elements = document.querySelectorAll('svg.icon--rating-star-half');

  // Check if elements were found
  if (elements.length > 0) {
    // For each element
    elements.forEach(function(element, index) {
      // Generate a unique id for the gradient
      var gradientId = 'gradient' + index;

      // Define the gradient in SVG markup
      var gradient = `
        <defs>
          <lineargradient id="${gradientId}" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:#ffd602;stop-opacity:1"></stop>
            <stop offset="50%" style="stop-color:#ffd602;stop-opacity:1"></stop>
            <stop offset="50%" style="stop-color:#ffffff;stop-opacity:1"></stop>
            <stop offset="100%" style="stop-color:#ffffff;stop-opacity:1"></stop>
          </lineargradient>
        </defs>
      `;

      // Insert the gradient markup at the beginning of the SVG
      element.insertAdjacentHTML('afterbegin', gradient);

      // Select the path element inside the SVG
      var path = element.querySelector('path');

      // If the path was found
      if (path) {
        // Update the fill attribute to use the gradient
        path.setAttribute('fill', 'url(#' + gradientId + ')');
      }
    });
  }

    // Get the <a> tag within the .announcement-bar__content-text .text-container element
    var link = document.querySelector('.announcement-bar__item.redirect .announcement-bar__content-text a');
    
    // Check if the <a> tag exists
    if (link) {
        // Get the href attribute from the <a> tag
        var href = link.getAttribute('href');
        
        // Get the button within the .announcement-bar__message element
        var button = document.querySelector('.announcement-bar__message button');
        
        // Check if the button exists
        if (button) {
            // Set the href attribute for the button
            //button.setAttribute('onclick', 'location.href="' + href + '";');
        }
    }

  let cartNotification = document.querySelector('.cart-notification');

    if (cartNotification) {
        let observer = new MutationObserver((mutationsList) => {
            for(let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
                    let cartNotificationLink = cartNotification.querySelector('.cart-notification__view-cart');

                    if (cartNotificationLink) {
                        cartNotificationLink.addEventListener('click', function(e) {
                            e.preventDefault();  // prevent the default link action

                            let headerIconLink = document.querySelector('.header__icon-list a[aria-label="Warenkorb"]');
                            if (headerIconLink) {
                                headerIconLink.click();  // simulate a click on the headerIconLink
                            }
                        });
                    }
                }
            }
        });

        observer.observe(cartNotification, { attributes: true });
    }


setTimeout(function() {
    if(document.body.classList.contains('template-collection')) {
        var productFacets = document.querySelectorAll('.product-facet');
        productFacets.forEach(function(productFacet) {
            var productListInners = productFacet.querySelectorAll('.product-list__inner');
            productListInners.forEach(function(productListInner) {
                var productItems = productListInner.querySelectorAll('.product-item');
                var shouldApplyOrder = false; // Flag to check if any highlight_bilder- with number found

                // First, check if any product-item has a highlight_bilder- followed by a number
                productItems.forEach(function(productItem) {
                    Array.from(productItem.classList).forEach(function(className) {
                        if (className.startsWith('highlight_bilder-') && !isNaN(className.split('highlight_bilder-')[1])) {
                            shouldApplyOrder = true;
                        }
                    });
                });

                // If highlight_bilder- with number is found, proceed to set the order
                if (shouldApplyOrder) {
                    var currentOrder = 1; // Keep track of the current order value
                    productItems.forEach(function(productItem) {
                        var orderValue = null;

                        Array.from(productItem.classList).forEach(function(className) {
                            if (className.startsWith('highlight_bilder-')) {
                                var number = className.split('highlight_bilder-')[1];
                                if (number && !isNaN(number)) {
                                    orderValue = parseInt(number, 10);
                                }
                            }
                        });

                        if (orderValue !== null) {
                            productItem.setAttribute('style', 'order:' + orderValue + ';');
                        } else {
                            while (Array.from(productListInner.querySelectorAll('.product-item')).some(item => Array.from(item.classList).includes('highlight_bilder-' + currentOrder))) {
                                currentOrder++;
                            }

                            productItem.setAttribute('style', 'order:' + currentOrder++ + ';');
                        }
                    });
                }
            });
        });

        setHighlightBilderHeight(); // Call the function here
    }
}, 10);



var productListInner = document.querySelectorAll('.product-list__inner');

productListInner.forEach(function(block, index) {
    setTimeout(function() {
        block.style.opacity = "1";
    }, 250 * (index + 1));
});


  
// Listen for click events on the entire document
document.addEventListener('click', function(event) {

  // Check if clicked element is an anchor with a hash (but not just '#')
  if (event.target.tagName === 'A' && event.target.getAttribute('href').startsWith('#') && event.target.getAttribute('href') !== '#') {
    
    // Check if the link is for the current page
    if (location.pathname.replace(/^\//, '') === event.target.pathname.replace(/^\//, '') && location.hostname === event.target.hostname) {
      
      // Get the target element
      let targetId = event.target.getAttribute('href').slice(1);
      let targetElement = document.getElementById(targetId) || document.getElementsByName(targetId)[0];
      
      if (targetElement) {
        event.preventDefault();  // Prevent default link behavior

        // Check if an element with class 'announcement-bar' exists
        let offsetValue = document.querySelector('.announcement-bar') ? 129 : 75;

        // Smooth scroll to the target element with the determined offset
        let topPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offsetValue;
        window.scroll({
          top: topPosition,
          behavior: 'smooth'
        });
      }
    }
  }
});




// Get the element to observe
const descriptionElem = document.getElementById('description');

// If the element does not exist, do nothing
if (!descriptionElem) {
    return;
}

// Define the callback for the MutationObserver
const callback = function(mutationsList) {
    // Check screen width
    if (window.innerWidth < 1000) return;

    for(let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Check if the 'show' class is present
            if (descriptionElem.classList.contains('show')) {
                const parentHeight = parseFloat(getComputedStyle(descriptionElem.closest('.image-with-text__text-wrapper')).height);
                const linkBarHeight = parseFloat(getComputedStyle(document.querySelector('link-bar')).height);

                setTimeout(function() {
                    descriptionElem.style.height = (parentHeight - linkBarHeight - 20) + 'px';
                }, 100); // waits 100 milliseconds before setting the height
            }
        }
    }
};

// Create an instance of the observer with the callback
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(descriptionElem, { attributes: true, attributeFilter: ['class'] });




  
});

window.addEventListener('resize', function() {
    clearTimeout(window.resizingTimeout);
    window.resizingTimeout = setTimeout(setHighlightBilderHeight, 100);
});

// add this in custom.js
function _addMeToCart(e, el) {
	e = e || window.event;
  	e.preventDefault();
  triggerEvent(document.documentElement, "theme:loading:start");
  let mainProductId = document.querySelector('.shopify-main-product-form input[name="id"]').value;

    let formData = {
      'items': [
        {
          'id': el.dataset.variant_id,
          'quantity': 1,
          'properties': { _bundle_id: mainProductId }
        },
        {
          'id': mainProductId,
          'quantity': 1
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((resp) => { 
      return resp.json();
    })
    .then((resp) => {
      triggerEvent(document.documentElement, "theme:loading:end");
      document.addEventListener('variant:added', function(event) {
         bubbles: true
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
      // this.dispatchEvent(new CustomEvent("cart-notification:show", {
      //   bubbles: true,
      //   cancelable: true,
      //   detail: {
      //     status: resp.ok ? "success" : "error",
      //     error: "Something went wrong"
      //   }
      // }));

    })
    .catch((err) => {
      console.error('Error: ' + err);
    })
}



document.addEventListener('cart:change', function(event) {

  
  // Get the removed product ID from the event
  var removedProductId = event.detail.product.id;

  // Fetch the product data from the server to get the connected products
  fetch('/products/' + removedProductId + '.json')
    .then(response => response.json())
    .then(data => {
      var connectedProductIds = data.product.metafields.custom.bundleprodukte;

      // Check if each connected product is in the cart
      connectedProductIds.forEach(function(connectedProductId) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            var item = cart.items.find(item => item.product_id === connectedProductId);

            // If the connected product is in the cart, remove it
            if (item) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: item.id,
                  quantity: 0,
                }),
              });
            }
          });
      });
    });
});







// Check if the element exists on the page
var slideshowElement = document.querySelector('.slideshow__slide-list');

if (slideshowElement) {
    var flkty = new Flickity(slideshowElement, {
        // options
        cellSelector: ".slide-show-item",
        cellAlign: "left",
        groupCells: false,
        friction: 0.4,
        prevNextButtons: true,
        pageDots: true,
        draggable: true,
        imagesLoaded: true,
        contain: true, // Don't show empty space at the beginning or end
        autoPlay: 5000
    });

    flkty.on('scroll', function(progress) {
        flkty.slides.forEach(function(slide, i) {
            var img = slide.cells[0].element.querySelector('.parallax');
            
            if (img) {  // Added another check here to ensure the image element exists
                var x = (slide.target + flkty.x) * -1/3;
                img.style.setProperty('transform', 'translateX(' + x + 'px)', 'important');
            }
        });
    });
}


window.onload = function() {
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                var element = document.querySelector('.drawer__title');
                if (element) {
                    var svgElement = element.querySelector('svg');
                    for (var i = 0; i < element.childNodes.length; i++) {
                        var node = element.childNodes[i];
                        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes("1 Produkte")) {
                            var newText = document.createTextNode(node.textContent.replace("1 Produkte", "1 Produkt"));
                            element.replaceChild(newText, node);
                        }
                    }
                }
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};
</a></a></a></span></drawer-content></product-variants>